/**
 * Calculates the position for horizontal media card placement based on row layout
 *
 * @param mediaCardIndex - The index of the current media card
 * @param itemsInRow - The number of items per row
 * @param maxIndex - The maximum valid index
 * @returns The calculated position index
 */
const horizontalMediaCardPosition = (mediaCardIndex: number, itemsInRow: number, maxIndex: number): number => {
  let position: number;
  if (mediaCardIndex === maxIndex) {
    return mediaCardIndex;
  }
  if (maxIndex < itemsInRow) {
    return maxIndex;
  }
  if (mediaCardIndex === 0 || Math.ceil((mediaCardIndex + 1) / itemsInRow) - 1 === 0) {
    position = itemsInRow - 1;
  } else {
    position = Math.ceil((mediaCardIndex + 1) / itemsInRow) * itemsInRow - 1;
  }
  return position;
};

export default horizontalMediaCardPosition;
